<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Vacaciones Empleados</span>
	  		    <v-spacer></v-spacer>
	  		    <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( puestos  , 'puestos')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
            >
              <v-icon small>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              color="orange"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>

          </v-card-title>

          <v-card-text>
            <v-row justify="end">
              <v-col cols="12" md="8">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  single-line
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="puestos"
							    class="elevation-0"
							    :search="search"
							    :page.sync="page"
			            @page-count="pageCount = $event"
							    :mobile-breakpoint="100"
			            hide-default-footer
			            dense
							  >
							    <!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.estatus="{ item }">
							      <v-chip 
							      	v-if="item.estatus == 1"
							      	small
							      	color="green"
							      	dark
							      >Aceptado</v-chip>

							      <v-chip 
							      	v-else-if="item.estatus == 2"
							      	small
							      	color="black"
							      	dark
							      >Rechazado</v-chip>

							      <v-chip 
							      	v-else
							      	small
							      	color="grey"
							      	dark
							      >Pendiente</v-chip>
							    </template>

							    <template v-slot:item.actions="{ item }">
							    	<v-btn 
							    		color="primary" 
							    		x-small
							    		@click="editItem(item)"
							    		class="mr-2"
							    	>
								      <v-icon small>mdi-magnify</v-icon>
							    	</v-btn>
							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		  <v-card-actions>
            <v-spacer></v-spacer>
            <v-pagination
              circle
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-card-actions>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
    <!-- Dialogo de editar o agregar-->
    <v-dialog
      v-model="dialog"
      max-width="800px"
      persistent
    >
      <v-card>
        <v-card-title>Datos de la compra</v-card-title>
        <v-card-text>
          
          <div>Cliente  : {{ editedItem.cliente     }} </div>
          <div>Pagado   :  $ {{ editedItem.pago     }}.00 </div>
          <div>Total    :  $ {{ editedItem.total    }}.00 </div>
          <div>Autorizó :  $ {{ editedItem.autorizo }}.00 </div>

          <v-data-table
            :headers="headersMercancia"
            :items="editedItem.detalle"
            class="elevation-0"
            v-if="editedItem.detalle"
            hide-default-footer
            :items-per-page="editedItem.detalle.lenght"
          >
            <template v-slot:item.total="{ item }">
              {{ ( item.cantidad * item.precio ).toFixed( 2 ) }}
            </template>

          </v-data-table>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="dialogConfirmaEntrega = true"
            color="primary"
            dark
          >Confirmar</v-btn>
         </v-card-actions>
      </v-card>
    </v-dialog>



    <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialogRechazo"
      max-width="400px"
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Ingresa un motivo de rechazo</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
        	<v-row>
        		<v-col cols="12">
		          <v-textarea
		            v-model="editedItem.motivo_rechazo"
		            label="Motivo"
		            filled
		            dense
		            :rows="3"
		            auto-grow
		          ></v-textarea>
        		</v-col>
        	</v-row>
	        
        </v-card-text>


        <v-card-actions>

        	<v-btn
            color="black"
            dark
            dense
            tile
            small
            icon
            @click="dialogRechazo = false"
            absolute
            top
            right
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            dense
            tile
            small
            @click="save( 2 )"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el departamento?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'

  export default {
  	components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],
    
    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
      	idsolicitud_vacaciones:0,
      	id_trabajador:null,
      	fecha_inicio: null,
      	fecha_final: null,
      	motivo: null,
      	estatus:0,
      	id_trabajador_acepto:0,
      	motivo_rechazo:'',
				fecha_creacion:null,
				deleted:null,
      },

      defaultItem: {
      	idsolicitud_vacaciones:0,
      	id_trabajador:null,
      	fecha_inicio: null,
      	fecha_final: null,
      	motivo: null,
      	estatus:0,
      	id_trabajador_acepto:0,
      	motivo_rechazo:'',
				fecha_creacion:null,
				deleted:null,
      },

      // Filtros: 
      incio:null,
			fin:null,

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      puestos: [],
      headers: [
        { text: 'ID'            , value: 'idsolicitud_vacaciones'       },
        { text: 'Solicitó'      , value: 'solicito'      },
        { text: 'Días '         , value: 'dias'          },
        { text: 'Aceptó'        , value: 'acepto'        },
        { text: 'Fecha inicio'  , value: 'fecha_inicio'  },
        { text: 'Fecha final'   , value: 'fecha_final'   },
        { text: 'Estatus'       , value: 'estatus'       },
        { text: 'Actions'       , value: 'actions', sortable: false },
      ],
      departamentos:[],
      dialogRechazo: false,

      headersMercancia: [
        { text: 'ID'            , value: 'idextras'       },
        { text: 'Producto'      , value: 'extra'          },
        { text: 'Precio'        , value: 'precio'         },
        { text: 'Cantidad'      , value: 'cantidad'       },
        { text: 'Total'         , value: 'total'          },
      ],
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar solicitud' : 'Editar solicitud'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

    },

    async created () {
      await this.initialize()
      await this.getDepartamentos( )
    },

    methods: {
      initialize () {
      	this.cargar = true
        this.puestos = []
        return this.$http.get('vacaciones.get/' + this.getdatosUsuario.id ).then(response=>{
        	this.puestos = response.body
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getDepartamentos () {
      	this.cargar = true
        this.departamentos = []
        return this.$http.get('departamentos.list').then(response=>{
        	this.departamentos = response.body
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.puestos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.puestos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
      	this.cargar = true
        // Lo mandapos por el EP
        this.editedItem.deleted = 1
        this.$http.put('puestos.update/' + this.editedItem.idsolicitud_vacaciones, this.editedItem).then(response=>{
        	this.cargar = true
        	this.closeDelete()
        	this.initialize()
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save ( estatus ) {
      
	      this.cargar = true

        if (this.editedIndex > -1) {
        	this.editedItem.estatus = estatus
        	this.editedItem.id_trabajador_acepto = this.getdatosUsuario.id
	        // Lo mandapos por el EP
          this.$http.put('vacaciones.update/' + this.editedItem.idsolicitud_vacaciones, this.editedItem).then(response=>{
            this.close()
          	this.validarSuccess( response.body.message )
          	this.initialize()
          	this.dialogRechazo = false
	        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })

        } else {

        	this.editedItem.id_trabajador = this.getdatosUsuario.id
	        // Lo mandapos por el EP
          this.$http.post('vacaciones.add', this.editedItem).then(response=>{
            this.close()
          	this.initialize()
          	this.dialogRechazo = false
	        	this.cargar = false
	        }).catch( error =>{
          	this.validarError( error )
        	}).finally( () => { this.cargar = false })
        }
      },
    },
  }
</script>


